export function scrollToAnchor() {
  // We have to manually scroll to the anchor (#element) element
  const element = document.getElementById(window.location.hash.substring(1));
  setTimeout(() => {
    if (!!element) {
      element.scrollIntoView();
    }
  }, 500);
}
